import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class ServiceScheduleService {

    constructor(private dataService: DataService) {
    };

    get(refresh: Boolean) {
        return this.dataService.getData('/api/serviceschedule', refresh);
    }

    // getLookUp(refresh: Boolean) {
    //     return this.dataService.getData('/api/serviceschedule/lookup', refresh);
    // }
    getLookUp(data: any, refresh: Boolean) {
        return this.dataService.getDataWithParams('/api/serviceschedule/lookup/', data, refresh);
    }
    getById(id: number) {
        return this.dataService.getRecord('/api/serviceschedule/' + id);
    }

    delete(id: number) {
        return this.dataService.delete('/api/serviceschedule/' + id).map(response => {
            this.dataService.clearCache();
            // this.dataService.clearRouteCache(this.route);
            return response;
        });
    }

    save(data: any) {
        return this.dataService.post('/api/serviceschedule', data).map(response => {
            return response;
        });
    }

    getPrioritys(refresh: boolean) {

        return this.dataService.getData('/api/lookup/prioritytype', refresh);
    }
    getMaintenanceType(refresh: boolean) {

        return this.dataService.getData('/api/lookup/maintenancetype', refresh);
    }

    getUomType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/uomtype', refresh);
    }
    getMachineType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/machinetype', refresh);
    }
    getexpensetype(refresh: boolean) {
        return this.dataService.getData('/api/lookup/expensetype', refresh);
    }

    getunitType(data:any, refresh: boolean) {

        return this.dataService.getData('/api/serviceschedule/uomtype/' + data.machineryType + '/'+ data.refId, refresh);
    }
    
    
}
